import React from 'react';
import type { FC } from 'react';
import type { DeploymentTopologyEnvironmentType } from '@wix/cli-astro-definitions';
import { Preview } from './Preview.js';

export const PreviewCommand: FC<{
  environment: DeploymentTopologyEnvironmentType;
  baseUrl?: string;
  label?: string;
  onPreviewCreated?: (args: { previewId: string; previewUrl?: string }) => void;
}> = ({ environment, baseUrl, label, onPreviewCreated }) => {
  return (
    <Preview
      baseUrl={baseUrl}
      onPreviewCreated={onPreviewCreated}
      environment={environment}
      label={label}
    />
  );
};
